const PRODUCTION_ADMIN_API_BASE_URL = "https://api.pennypantryapp.com";

function normalizeBaseUrl(url) {
  return url.replace(/\/+$/, "");
}

function resolveAdminMonitoringApiBaseUrl() {
  const configuredUrl = process.env.REACT_APP_ADMIN_API_URL?.trim();
  if (configuredUrl && configuredUrl.startsWith("https://")) {
    return normalizeBaseUrl(configuredUrl);
  }
  return PRODUCTION_ADMIN_API_BASE_URL;
}

export const ADMIN_MONITORING_API_BASE_URL = resolveAdminMonitoringApiBaseUrl();

export function buildAdminMonitoringUrl(path) {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${ADMIN_MONITORING_API_BASE_URL}${normalizedPath}`;
}
